import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-0.5" }
const _hoisted_2 = { class: "flex-1 min-w-0" }

import { computed } from 'vue'
import CloseIcon from '../icons/CloseIcon.vue';

type ToastType = 'error' | 'success' | 'info' | 'warning'


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    show: { type: Boolean },
    type: {},
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props



const t = computed<ToastType>(() => props.type ?? 'info')

const wrapperClass = computed(() => {
  switch (t.value) {
    case 'error':
      return 'bg-red-50/95 dark:bg-red-500/10 border-red-200 dark:border-red-500/20'
    case 'success':
      return 'bg-emerald-50/95 dark:bg-emerald-500/10 border-emerald-200 dark:border-emerald-500/20'
    case 'warning':
      return 'bg-amber-50/95 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/20'
    default:
      return 'bg-slate-50/95 dark:bg-slate-800/80 border-slate-200 dark:border-slate-700/50'
  }
})

const dotClass = computed(() => {
  switch (t.value) {
    case 'error':
      return 'bg-red-500'
    case 'success':
      return 'bg-emerald-500'
    case 'warning':
      return 'bg-amber-500'
    default:
      return 'bg-slate-400'
  }
})

const titleClass = computed(() => {
  switch (t.value) {
    case 'error':
      return 'text-red-800 dark:text-red-200'
    case 'success':
      return 'text-emerald-800 dark:text-emerald-200'
    case 'warning':
      return 'text-amber-800 dark:text-amber-200'
    default:
      return 'text-slate-800 dark:text-slate-100'
  }
})

const messageClass = computed(() => {
  switch (t.value) {
    case 'error':
      return 'text-red-700 dark:text-red-200/90'
    case 'success':
      return 'text-emerald-700 dark:text-emerald-200/90'
    case 'warning':
      return 'text-amber-700 dark:text-amber-200/90'
    default:
      return 'text-slate-600 dark:text-slate-300'
  }
})

const closeClass = computed(() => {
  switch (t.value) {
    case 'error':
      return 'text-red-700 dark:text-red-200'
    case 'success':
      return 'text-emerald-700 dark:text-emerald-200'
    case 'warning':
      return 'text-amber-700 dark:text-amber-200'
    default:
      return 'text-slate-600 dark:text-slate-200'
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["rounded-2xl border shadow-lg backdrop-blur-sm px-4 py-3 flex gap-3 items-start", wrapperClass.value]),
        role: "status",
        "aria-live": "polite"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(["inline-block w-2.5 h-2.5 rounded-full", dotClass.value])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", {
            class: _normalizeClass(["text-sm font-semibold leading-5", titleClass.value])
          }, _toDisplayString(__props.title), 3),
          (__props.message)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(["text-sm mt-1 leading-5", messageClass.value])
              }, _toDisplayString(__props.message), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["rounded-lg px-2 py-1 text-sm font-semibold hover:opacity-80 transition", closeClass.value]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          "aria-label": "Close toast"
        }, [
          _createVNode(CloseIcon)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})